module.exports = __webpack_public_path__ + "img/framboise_done.93274bac.jpg";